import React from "react";
import { Col, Row } from "react-bootstrap";
import { ArticleItemSideBar } from "../components/Sidebar/Articles/ArticleItemSideBar";
import qwMap from "../assets/images/QWMap.jpg";
import {
  StyledListContainer,
  StyledListSection,
  StyledSectionHeaderComponent,
  StyledEmergencyHeader,
  StaticBodySectionHeader,
} from "../utils/common-styles";
import { Helmet } from "react-helmet";
import { UrlFixer } from "../utils/utils";

export const ReportAnIssuePage = (props) => {

  return (
    <>
      <Helmet>
        <title>Reporting an issue - The Friends of Queen's Wood</title>
        <meta name="description" content="Find out how you can report an issue with The Friends of Queen's Wood" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Reporting an issue - The Friends of Queen's Wood" />
        <meta property="og:description" content="Find out how you can report an issue with The Friends of Queen's Wood" />
        <meta property="og:url" content={`${window.location.origin}`} />
        <meta property="og:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
        <meta name="twitter:title" content="The Friends of Queen\'s Wood" />
        <meta name="twitter:description" content="Find out how you can report an issue with The Friends of Queen\'s Wood" />
        <meta name="twitter:image" content={UrlFixer('/assets/og-large-profile.jpg')} />
      </Helmet>
      <StyledSectionHeaderComponent title="Report an Issue" />
      <StyledListSection>
        <StyledListContainer>
          <Row>
            <Col xs={12} md={9}>
              <p style={{ marginTop: "25px" }}>&nbsp;</p>
              <StyledEmergencyHeader>
                <h2>In the event of an emergency</h2>
                <p>
                  In all cases, please dial 999 and ask for the appropriate
                  service.
                </p>
              </StyledEmergencyHeader>
              <p style={{ marginTop: "25px" }}>&nbsp;</p>
              <main>
                <StaticBodySectionHeader>Anti-social behaviour</StaticBodySectionHeader>
                <p>
                  To notify the police of anti-social behaviour, please dial 101
                  and report any incidents using the map below to identify the
                  location within the wood.
                </p>

                <StaticBodySectionHeader>Avian (bird) flu</StaticBodySectionHeader>
                <p>
                  Avian flu is still an issue in the UK. In the event that you
                  come across a dead bird, please do not touch it. Instead,
                  please use <a href="https://www.gov.uk/guidance/report-dead-wild-birds" target="_blank" rel="noreferrer">this form</a> to notify DeFRA. We would also like to be
                  notified at the same time so please do also send us an email:{" "}
                  <a href="mailto:info@fqw.org.uk">info@fqw.org.uk</a>
                </p>

                <StaticBodySectionHeader>Fly-tipping</StaticBodySectionHeader>
                <p>
                  There have been increasingly frequent incidents of fly-tipping
                  occurring on Queen's Wood road itself. Haringey Council are
                  subscribers to the "Love Clean Streets" service. Please
                  consider adding their app to your phone if you're a frequent
                  user of Queen's Wood. <a href="https://lovecleanstreets.info/" target="_blank" rel="noreferrer">Click to find out more about &quot;Love Clean Streets&quot;</a>.
                </p>

                <StaticBodySectionHeader>Contacting the Council</StaticBodySectionHeader>
                <p>
                  Reporting any other type of problem can be done online via the
                  Haringey Council web site. You can begin by visiting their <a href="https://www.haringey.gov.uk/contact/report-a-problem" target="_blank" rel="noreferrer">Report a problem page</a>
                </p>
              </main>
              <img
                src={qwMap}
                title="Map of the different compartments in Queen's Wood"
                alt="Map of the different compartments in Queen's Wood"
              />
            </Col>
            <Col xs={12} md={3}>
              <ArticleItemSideBar post={{}} other={[]} />
            </Col>
          </Row>
        </StyledListContainer>
      </StyledListSection>
    </>
  );
};
